import React, { useEffect, useState } from 'react'
import { CommunicationHeader } from '../customer/header';
import { FormikProvider, useFormik } from 'formik';
import { Tab, Nav } from "react-bootstrap";
import ReConfirm from './reConfirm';
import { CharacterDisplay } from '../../component/UserInfoCell';
import { useParams } from 'react-router-dom';
import Language from './language';
import { projectByRequest } from '../api';
import { FullPageLoader } from '../../component/helper';
import FormikComponent from '../../component/formikComponent';
import { Footer } from '../userLayout/Footer';
import { TokenBaseSupportForm } from '../customer/supportFiles/tokenBaseSupport';

const CommunicationHome = () => {
    const labelMap = {
        txn_sms: "SMS",
        txn_whatsapp: "WhatsApp",
        txn_email: "Email",
        txn_phone: "Phone",
        promo_sms: "SMS",
        promo_whatsapp: "WhatsApp",
        promo_email: "Email",
        promo_phone: "Phone"
    };
    const { lang, request } = useParams();
    const [reConfirm, setReConfirm] = useState(false)
    const [activeTab, setActiveTab] = useState("transactional");
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            communicationType: {
                // txn_sms: "yes",
                // txn_whatsapp: "yes",
                // txn_email: "yes",
                // txn_phone: "yes",
                promo_sms: "yes",
                promo_whatsapp: "yes",
                promo_email: "yes",
                promo_phone: "yes"
            },
            selected_language: lang

        },
        // validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setReConfirm(true)

        },
    })

    useEffect(() => {
        setLoading(true);
        if (request) {
            projectByRequest({ request_token: request }).then((d) => {
                setData(d?.data);
                formik.setValues({
                    communicationType: d?.data?.communicationType || {
                        promo_sms: "yes",
                        promo_whatsapp: "yes",
                        promo_email: "yes",
                        promo_phone: "yes"
                    }
                });

                setLoading(false)
            });
        }
    }, [request, lang]);

    return (
        <div className="d-flex  justify-content-center align-items-center">

            < div className='bg-white d-flex flex-column  w-800px  vh-100' >
                {loading && <FullPageLoader />}
                <CommunicationHeader heading="Schemes" data={data} />
                {
                    (lang && request) ?
                        <>
                            <FormikProvider value={formik}>
                                {
                                    reConfirm ? <ReConfirm setReConfirm={setReConfirm} values={formik.values} data={data} /> :
                                        <>
                                            <div style={{ background: '#FFF5F8' }} className="card  rounded-0">
                                                <div className="card-header border-0 py-2 px-5 d-flex justify-content-between align-items-center">
                                                    <div className="d-flex flex-column">
                                                        <div className="text-gray-800 fw-semibolder text-capitalize fs-5">
                                                            <i className="bi bi-person-fill me-1 text-dark fs-4"></i> {data?.user_name}
                                                        </div>
                                                        <div className="fs-7 fw-semibold text-gray-800">
                                                            <i className="bi bi-building-fill me-2 text-dark"></i> {data?.project_name}
                                                        </div>
                                                    </div>

                                                    <div className="d-flex flex-column justify-content-end align-items-end  text-end gap-1">
                                                        <div className="fs-7 fw-semibold text-gray-800  ">
                                                            <div>
                                                                <i className="bi bi-telephone-fill me-1 text-dark"></i>
                                                                {data?.phone}
                                                            </div>

                                                        </div>
                                                        <div className="fs-7 fw-semibold text-gray-800  ">

                                                            <div>
                                                                <i className="bi bi-whatsapp text-dark me-1"></i>
                                                                {data?.whatsapp_number ? data?.whatsapp_number : '--'}
                                                            </div>
                                                        </div>
                                                        <div className="fs-7 fw-semibold text-gray-800 d-flex align-items-center gap-1">
                                                            <i className="bi bi-envelope-fill me-1 text-dark"></i>
                                                            <CharacterDisplay character={data?.email} count="22" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="px-4">
                                                <div className='card p-2 ps-4 my-4' style={{ backgroundColor: "#f8f8f8", border: "0.5px solid #f2f2f2" }}>
                                                    <div className='fs-6 '>
                                                        {activeTab === 'promotional' &&
                                                            <>  {data?.promotional_header}</>
                                                        }
                                                        {activeTab === 'transactional' &&
                                                            <>{data?.transactional_header}</>
                                                        }
                                                        {activeTab === 'help' &&
                                                            <>{data?.help_header}</>
                                                        }
                                                    </div>
                                                </div>


                                                <div className="card" >
                                                    <div className="card-header px-0 mb-2 border-0" style={{ minHeight: "40px" }}>
                                                        <Nav variant="tabs" className="border-0 w-100 d-flex ">
                                                            {["transactional", "promotional", "help"].map((tab, index) => (
                                                                <Nav.Item key={tab} style={{ width: "33%" }}>
                                                                    <Nav.Link
                                                                        eventKey={tab}
                                                                        active={activeTab === tab}
                                                                        onClick={() => setActiveTab(tab)}
                                                                        className={`p-3 fs-6 fw-semibold text-center ${activeTab === tab ? 'bg-danger' : '#c4c4c4'} border-0 me-1`}
                                                                        style={{
                                                                            background: activeTab === tab ? "#f1416c" : "#c4c4c4",
                                                                            color: activeTab === tab ? "#fff" : "#333",
                                                                            borderTopRightRadius: "18px",
                                                                            boxShadow: activeTab === tab ? "0 4px 6px rgba(0, 0, 0, 0.2)" : "none",
                                                                            transition: "all 0.3s ease-in-out",
                                                                        }}
                                                                    >
                                                                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                                                    </Nav.Link>
                                                                </Nav.Item>
                                                            ))}
                                                        </Nav>
                                                    </div>
                                                    <div className="card-body p-0">
                                                        <Tab.Container activeKey={activeTab}>
                                                            <Tab.Content>
                                                                {/* Promotional Communication Tab */}
                                                                <Tab.Pane eventKey="promotional">
                                                                    <div className="rounded p-4 fs-6 shadow-sm  text-gray-600 mb-2" style={{ border: "1px solid  #d0d0d0 " }}>
                                                                        {data?.permotion_text}
                                                                    </div>
                                                                    <form id="kt_form" className="form fv-plugins-bootstrap5 fv-plugins-framework"
                                                                        onSubmit={formik.handleSubmit} noValidate>

                                                                        <div className="">
                                                                            <div style={{ border: '1px solid #E6E6E6' }} className="card ">
                                                                                <div className="card-header px-4  py-2 bg-secondary" style={{ minHeight: '20px' }}>
                                                                                    <div className="card-title fw-semibold fs-5 ">
                                                                                        <label className="required fw-semibold fs-6 ">Promotional Communication Type</label>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="p-4">
                                                                                    <FormikComponent
                                                                                        labelMap={{
                                                                                            promo_sms: "SMS",
                                                                                            promo_whatsapp: "WhatsApp",
                                                                                            promo_email: "Email",
                                                                                            promo_phone: "Phone"
                                                                                        }}
                                                                                        disabled={false}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <button type="submit" className="btn  mt-2 w-100 btn-primary text-white" style={{ background: '#f1416c' }}>Save</button>
                                                                    </form>
                                                                </Tab.Pane>

                                                                {/* Transactional Communication Tab */}
                                                                <Tab.Pane eventKey="transactional">
                                                                    <div className="rounded p-4 fs-6 shadow-sm  text-gray-600 mb-2" style={{ border: "1px solid  #d0d0d0 " }}>
                                                                        {data?.transcation_text}
                                                                    </div>
                                                                    <div className="">
                                                                        <div style={{ border: '1px solid #E6E6E6' }} className="card ">
                                                                            <div className="card-header px-4  py-2 bg-secondary" style={{ minHeight: '20px' }}>
                                                                                <div className="card-title fw-semibold fs-5 ">
                                                                                    <label className="required fw-semibold fs-6 ">Transactional Communication Type</label>
                                                                                </div>
                                                                            </div>
                                                                            <div className="p-4">
                                                                                <div className="fv-row fv-plugins-icon-container">
                                                                                    <div className="d-flex flex-column justify-content-between gap-3">
                                                                                        {
                                                                                            Object.keys(labelMap)
                                                                                                .filter(key => key.startsWith("txn")) // Filter keys starting with 'txn'
                                                                                                .map((option) => (
                                                                                                    < div className='d-flex justify-content-between'>
                                                                                                        <label
                                                                                                            htmlFor={`promotionalCommunicationType-${option}`}
                                                                                                            className="form-check-label fs-6 fw-semibold"
                                                                                                        >
                                                                                                            {labelMap[option] || option.replace("txn_", "")} {/* Use labelMap or fallback to key without txn_ */}
                                                                                                        </label>
                                                                                                        <div key={option} className="form-check form-switch">
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                id={`promotionalCommunicationType-${option}`}
                                                                                                                name="communicationType" // Make sure it is the correct name for the Formik field
                                                                                                                value={option}
                                                                                                                disabled
                                                                                                                checked // Check if the value is 'yes'
                                                                                                                className="form-check-input text-success border-success bg-success"
                                                                                                            />

                                                                                                        </div>
                                                                                                    </div>
                                                                                                ))
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="help">
                                                                    <TokenBaseSupportForm data={data} />
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </Tab.Container>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                }
                            </FormikProvider>
                        </>
                        : <Language data={data} />
                }
                <Footer />
            </div >
        </div >

    )
}

export default CommunicationHome